import React from 'react'
import { Button, ButtonGroup } from 'reactstrap'

const UrlsPagination = ({ urls, onToggleUrl }) => {
  const [currentIndex, setCurrentIndex] = React.useState(0)

  const onClickToToggle = (next = true) => {
    const possibleNext = currentIndex + 1
    const possiblePrevious = currentIndex - 1

    if (next) {
      setCurrentIndex(possibleNext)
      onToggleUrl(urls[possibleNext].target)
    } else {
      setCurrentIndex(possiblePrevious)
      onToggleUrl(urls[possiblePrevious].target)
    }
  }

  return (
    <div className="d-flex justify-content-between">
      {
        urls.length > 1 && (
          <ButtonGroup size="sm">
            <Button
              onClick={() => onClickToToggle(false)}
              disabled={currentIndex === 0}
            >
              {"<"}
            </Button>

            <Button
              onClick={() => onClickToToggle()}
              disabled={currentIndex === urls.length - 1}
            >
              {">"}
            </Button>
          </ButtonGroup>
        )
      }

      <span className="ml-3 truncate align-self-center font-weight-semibold">
        <a href={urls[currentIndex].target || '#'} rel="noopener noreferrer" target="_blank">
          {urls[currentIndex].target || ''}
        </a>
      </span>
    </div>
  )
}

export default UrlsPagination
